import Capacity from "@model/Capacity";
import EventBus, { CONTRACT_UPDATED, ENTITY_CREATED, ENTITY_DELETED, IDisposable } from "@util/EventBus";
import AssociatedListViewModel from "@vm/List/AssociatedListViewModel";
import { inject, injectable } from "inversify";
import TYPES from "../../inversify.types";
// There is error in babel
// remove this after https://github.com/babel/babel/issues/9838
// will be fixed
void TYPES;
void inject;

@injectable()
export default class CapacityListVM extends AssociatedListViewModel<Capacity, AssociatedRepository<Capacity>> {
  static defaults = {
    order: {
      field: "valid_from",
      direction: "desc",
    },
    visibleFilters: ["valid_from", "valid_to"],
  };

  // Current values from params
  private employeeId: number;
  private contractId?: number;

  private readonly eventHandlers: IDisposable[] = [];

  constructor(@inject(TYPES.CapacityRepository) repository: AssociatedRepository<Capacity>) {
    super(repository);
    this.scroll = false;
  }

  async init() {
    this.eventHandlers.push(EventBus.on(CONTRACT_UPDATED, this.fetchList));
    this.eventHandlers.push(EventBus.on(ENTITY_DELETED, this.fetchList));
    this.eventHandlers.push(EventBus.on(ENTITY_CREATED, this.fetchList));
  }

  async setId(employeeId: number, contractId?: number) {
    if (this.employeeId == employeeId && this.contractId == contractId) {
      return;
    }

    // Save values
    this.employeeId = employeeId;
    this.contractId = contractId;

    // Set repository and reload later
    this.repository.setId(employeeId);
    this.setFilters({}, undefined, false, false);
  }

  /**
   * Its called from view on componentWillUmount to prevent memory leak
   */
  dispose() {
    this.eventHandlers.forEach(x => x.dispose());
  }

  /**
   * Contract_id is pernament filter
   */
  // tslint:disable-next-line: bool-param-default
  setFilters(filters: FilterValues, visible?: string[], skipFetching?: boolean, save?: boolean) {
    const filtersWithContract: FilterValues = {
      ...filters,
      rate_contract_id: {
        operator: "in",
        values: this.contractId,
      },
    };

    return super.setFilters(filtersWithContract, visible, skipFetching, save);
  }
}
